import React from 'react';
import { Link } from 'react-router-dom';
import { PURPLE } from '../../utils/designUtils';

export default function Unauthorized() {
    return (
        <div style={{
            display: 'flex', justifyContent: 'center', alignItems: 'flex-start',
            minHeight: '100vh', background: '#f5f4fa', paddingTop: '10vh',
        }}>
            <div style={{
                textAlign: 'center', padding: '40px',
                background: 'white', borderRadius: 16,
                border: '1px solid rgba(124,107,217,0.12)',
                boxShadow: '0 4px 24px rgba(124,107,217,0.10)',
                minWidth: 300,
            }}>
                <h3 style={{ marginBottom: 24, color: '#1f1d2e', fontWeight: 700, fontSize: 20, marginTop: 0 }}>
                    접근 권한이 없습니다.
                </h3>
                <Link to="/" style={{
                    display: 'inline-block', padding: '10px 24px', borderRadius: 10,
                    background: `linear-gradient(135deg, ${PURPLE}, #9b8de8)`,
                    color: 'white', textDecoration: 'none', fontWeight: 600, fontSize: 14,
                    fontFamily: 'inherit',
                }}>첫 화면으로 이동</Link>
            </div>
        </div>
    );
}
